export const THomepagePersonalizationVariation = {
  Default: false,
  V2: true
};

export enum TGameEmphasisVariation {
  V2 = '1',
  Default = '0'
}
